<template>
  <div class="medical-record__modal">
    <div class="modal__header">
      <div class="modal__info-group-1">
        <div class="info-group-1__item">
          <div class="info-group-1__img-profile">
            <img :src="photoFallback(recordData.patient.photo)" alt="" />
          </div>

          <div class="info-group__group">
            <div>
              <h6 class="info-group__title">
                {{ recordData.patient.name }}
              </h6>
            </div>
          </div>
        </div>

        <div class="info-group__line">&nbsp;</div>

        <div class="info-group-1__item">
          <div class="info-group__group">
            <div>
              <h6 class="info-group__title-small">Telefone</h6>
            </div>
            <span>
              <p class="info-group__subtitle">
                {{ this.maskedPhoneNumber(recordData.patient.phone_number) }}
              </p>
            </span>
            <div>
              <h6 class="info-group__title-small">E-Mail</h6>
            </div>
            <span>
              <p class="info-group__subtitle">
                {{ recordData.patient.email }}
              </p>
            </span>
          </div>
        </div>

        <div class="info-group__line">&nbsp;</div>

        <div class="info-group-1__item">
          <div class="info-group__group">
            <sub>
              <h6 class="info-group__title-small">Observações</h6>
            </sub>
            <span>
              <p class="info-group__subtitle">
                {{ recordData.observation || "Nenhuma observação" }}
              </p>
            </span>
          </div>
        </div>
      </div>

      <hr />

      <div>
        <PatientRecordNotesHistory :appointment-id="recordData.appointment_id">
          <template #title>
            <h4>Histórico de Atendimentos</h4>
          </template>
        </PatientRecordNotesHistory>
      </div>

      <!-- <div class="modal__info-group-2">
        <div class="info-group-2__item">
          <div class="info-group__group">
            <div>
              <h6 class="info-group__title-small">Última consulta</h6>
            </div>

            <span class="info-group__subtitle">20 de Novembro de 2020</span>
          </div>

          <div class="info-group__group">
            <div>
              <h6 class="info-group__title-small">
                Exames solicitados por você
              </h6>
            </div>

            <span class="info-group__subtitle"
              >Hemograma, Colesterol, Glicemia e Transaminases (ALT e AST) ou
              TPG TGO</span
            >
          </div>
        </div>

        <div class="info-group-2__item">
          <div class="info-group__group">
            <div class="info-group-2__clinical-data">
              <span class="clinical-data__title">OUTROS DADOS CLÍNICOS</span>
              <img src="../assets/images/arrow-down-icon.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <hr /> -->
    </div>
    <!-- Modal table -->
    <div class="modal-table">
      <div class="modal-table__header">
        <div class="modal-table__header-date">
          <!-- <div class="modal-table__header-date--arrow-btn">
            <img src="../assets/images/arrow-left-icon.svg" />
          </div>

          <div class="modal-table__header-date-title">Dezembro 2020</div>

          <div class="modal-table__header-date--arrow-btn">
            <img src="../assets/images/arrow-right-icon.svg" />
          </div> -->
        </div>

        <div class="modal-table__header-symptoms">
          <!-- <div v-if="recordData.symptoms.length">
            <div class="modal-table__header-symptoms--list">
              <div class="modal-table__header-symptoms--list-item">
                <div class="symptom-slot low" />
                Estou bem
              </div>

              <div class="modal-table__header-symptoms--list-item">
                <div class="symptom-slot medium" />
                Nada bem
              </div>

              <div class="modal-table__header-symptoms--list-item">
                <div class="symptom-slot high" />
                Muito grave
              </div>

              <div class="modal-table__header-symptoms--list-item">
                <div class="symptom-slot absent" />
                Não feito
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- Modal table table -->
      <div class="modal-table__symptoms-table">
        <!-- <div v-if="recordData.symptoms.length">
          <table>
            <thead>
              <tr>
                <th>Sintomas</th>
                <th v-for="(th, index) in 31" :key="index">
                  {{ th }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(symptom, index) in recordData.symptoms" :key="index">
                <td>{{ symptom.name }}</td>
                <td
                  v-for="(report, idx) in filteredSymptomsReports(
                    symptom.report
                  )"
                  :key="idx"
                >
                  <div
                    class="symptoms-table-slot"
                    :class="symptomIntensityClass(report.intensity)"
                  >
                    &nbsp;
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-else
          class="row d-flex align-items-center justify-content-center"
        >
          Nenhum sintoma informado
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { authComputed, userMethods } from "../state/helpers";
import PatientRecordNotesHistory from './PatientRecordNotesHistory.vue';
import { phoneMask } from "../utils/masks/phoneNumber";

export default {
  name: "MedicalRecord",
  components: {
    PatientRecordNotesHistory,
  },
  props: { recordData: { type: Object, default: null } },
  methods: {
    ...userMethods,
    filteredSymptomsReports(report) {
      const newReportArray = [];
      for (let i = 1; i <= 31; i++) {
        let equals = null;
        report.map(item => {
          if (item.created_at == i) {
            equals = item;
          }
        });
        if (equals) {
          newReportArray.push(equals);
        } else {
          newReportArray.push({ created_at: `${i}`, intensity: "absent" });
        }
      }
      return newReportArray;
    },
    symptomIntensityClass(intensity) {
      let classStyle = "";
      switch (intensity) {
        case "low":
          classStyle = "low";
          break;
        case "middle":
          classStyle = "medium";
          break;
        case "hight":
          classStyle = "high";
          break;
        case "absent":
          classStyle = "absent";
          break;
      }
      return classStyle;
    },
    maskedPhoneNumber(input) {
      return phoneMask(input);
    },
    photoFallback(src) {
      return src || require("./../assets/images/doctor-img.jpg");
    }
  },
  computed: {
    ...authComputed
  },
};
</script>

<style lang="css" scoped>
.history_title {
  margin-bottom: 2rem;
  padding: 0px 20px;
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 16px;
  letter-spacing: 1px;
}
.medical-record__modal {
  font-family: "Inter", sans-serif;
  letter-spacing: -0.5px;
  font-style: normal;
}
/* INFO GROUP 1*/
.modal__info-group-1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.info-group-1__item:nth-child(1) {
  flex: 2;
  display: flex;
  align-items: center;
  padding: 0px;
  margin: 0px;
}
.info-group-1__item:nth-child(3) {
  flex: 1;
}
.info-group-1__item:nth-child(5) {
  flex: 2;
}
.info-group__line {
  border-right: solid 1px #dddddd;
  margin: 20px 0px;
}
@media (max-width: 1024px) {
  .modal__info-group-1 {
    flex-direction: column;
  }

  .info-group__line {
    border-right: none;
    border-bottom: solid 1px #dddddd;
  }
}
.info-group-1__img-profile img {
  width: 95px;
  height: 95px;
  border-radius: 8px;
}
.info-group__group {
  padding: 0.5em 2em;
}
.info-group__title {
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 18px;
}
.info-group__title-small {
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 16px;
}
.info-group__subtitle {
  font-weight: 500;
  font-size: 14px;
  color: #717171;
}
/* INFO GROUP 2 */
.modal__info-group-2 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.info-group-2__item:nth-child(1) {
  display: flex;
  align-items: center;
}
@media (max-width: 1024px) {
  .info-group-2__item:nth-child(1) {
    flex-wrap: wrap;
  }
}
.info-group-2__clinical-data {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.clinical-data__title {
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 14px;
  margin-right: 10px;
}
@media (max-width: 1024px) {
  .info-group-2__item:nth-child(2) {
    margin-top: 40px;
  }
}
/* MODAL TABLE HEADER*/
.modal-table__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 40px;
}
.modal-table__header-date {
  display: flex;
  align-items: center;
}
@media (max-width: 1024px) {
  .modal-table__header {
    flex-direction: column;
    justify-content: center;
  }

  .modal-table__header-date {
    margin-bottom: 40px;
  }
}
.modal-table__header-date--arrow-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #dddddd;
  border-radius: 8px;
  height: 40px;
  width: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.modal-table__header-date--arrow-btn:hover {
  border: solid 1px #222222;
}
.modal-table__header-date-title {
  padding: 0px 20px;
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.modal-table__header-symptoms--list {
  display: flex;
  align-items: center;
}
.modal-table__header-symptoms--list-item {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: #717171;
}
.modal-table__header-symptoms--list-item:not(:last-child) {
  margin-right: 20px;
}
.symptom-slot {
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
  margin-right: 10px;
}
.low {
  background: #426B83;
}
.medium {
  background: #DFA25B;
}
.high {
  background: #D38484;
}
.absent {
  background: #F2F2F2;
}
@media (max-width: 767px) {
  .symptom-slot {
    height: 24px;
    width: 32px;
    border-radius: 6px;
  }
}

/* MODAL TABLE TABLE */
.modal-table__symptoms-table {
  overflow: auto;
  min-height: 18rem;
}
.modal-table__symptoms-table thead tr th {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 12px;
  color: #222222;
  padding: 0px 10px;
  margin: 0px;
  text-align: center;
}
.modal-table__symptoms-table thead tr th:first-child {
  font-size: 14px;
  margin: 0px;
  padding-right: 40px !important;
  font-weight: 600 !important;
}
.modal-table__symptoms-table tbody tr td:first-child {
  padding: 20px 10px;
  color: #222222;
  font-weight: 500;
  font-size: 12px;
}
.symptoms-table-slot {
  height: 1rem;
  width: 1rem;
  margin: 5px;
  border-radius: 50%;
}
</style>
